/* VAT display toggle.
   1) Wires up the Inc/Ex VAT buttons; preference is remembered per browser.
   2) Converts prices rendered client-side by the Algolia app (instant-search cards and the autocomplete dropdown),
      which cannot use the Liquid dual-price spans. Prices in those elements are assumed to be VAT-inclusive GBP. */
(function () {
  var VAT = 1.2;
  var SEL = '.ais-hit--price, .ais-hit--price-discount, .ais-hit--price-striked, .aa-ItemContentPrice, .aa-ItemContentPriceCurrent, .aa-ItemContentPriceDiscounted';
  var MONEY = /£\s?\d[\d,]*(?:\.\d{1,2})?/g;
  var originals = new WeakMap();
  var busy = false;
  var scheduled = false;
  var observer = null;

  function mode() {
    return document.documentElement.getAttribute('data-vat') === 'ex' ? 'ex' : 'inc';
  }

  function fmt(n) {
    return '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function convertText(orig, m) {
    if (m === 'inc') return orig;
    return orig.replace(MONEY, function (s) {
      var inc = parseFloat(s.replace(/[£\s,]/g, ''));
      if (isNaN(inc)) return s;
      return fmt(Math.round((inc * 100) / VAT) / 100);
    });
  }

  function processElement(el, m) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    var changed = false;
    while ((node = walker.nextNode())) {
      var current = node.nodeValue;
      if (!MONEY.test(current) && !originals.has(node)) { MONEY.lastIndex = 0; continue; }
      MONEY.lastIndex = 0;
      var rec = originals.get(node);
      /* If the text no longer matches what we last wrote, Algolia re-rendered it: treat it as a new original. */
      if (!rec || rec.written !== current) {
        rec = { orig: current, written: current };
        originals.set(node, rec);
      }
      var next = convertText(rec.orig, m);
      if (next !== current) { node.nodeValue = next; }
      rec.written = next;
      changed = true;
    }
    if (changed) { el.setAttribute('data-vat-algolia', m); }
  }

  function applyAlgolia() {
    if (busy) return;
    busy = true;
    if (observer) observer.disconnect();
    try {
      var m = mode();
      document.querySelectorAll(SEL).forEach(function (el) {
        if (el.querySelector(SEL)) return; /* only leaf price elements */
        processElement(el, m);
      });
    } catch (e) { /* never break the page */ }
    if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    busy = false;
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; applyAlgolia(); });
  }

  function apply(m) {
    document.documentElement.setAttribute('data-vat', m);
    document.querySelectorAll('.vat-toggle__btn').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-vat-mode') === m));
    });
    applyAlgolia();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.vat-toggle__btn');
    if (!b) return;
    var m = b.getAttribute('data-vat-mode');
    apply(m);
    try { localStorage.setItem('ebp_vat', m); } catch (err) {}
  });

  function init() {
    if ('MutationObserver' in window && document.body) {
      observer = new MutationObserver(schedule);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    apply(mode());
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
